<template>
  <ats
    v-bind="$props"
    service="successfactors"
    :savingConf="savingConf"
    :credential="{ apiEndpoint: '', companyId: '', clientId: '', userId: '', privateKey: '', publicKey: '' }"
    :cached="true"
    :multiai="true"
    @input="onInput">
    <template v-slot:credential="{ credential }">
      <div>
        <label for="apiEndpoint">API Endpoint</label>
        <input v-model="credential.apiEndpoint" id="apiEndpoint" name="apiEndpoint" placeholder="https://api012.successfactors.eu/"/>
        <modified :enable="value.credential && value.credential.apiEndpoint !== credential.apiEndpoint"/>
      </div>
      <div>
        <label for="companyId">Company ID</label>
        <input v-model="credential.companyId" id="companyId" name="companyId"/>
        <modified :enable="value.credential && value.credential.companyId !== credential.companyId"/>
      </div>
      <div>
        <label for="clientId">Client ID</label>
        <input v-model="credential.clientId" id="clientId" name="clientId"/>
        <modified :enable="value.credential && value.credential.clientId !== credential.clientId"/>
      </div>
      <div>
        <label for="userId">User ID</label>
        <input v-model="credential.userId" id="userId" name="userId"/>
        <modified :enable="value.credential && value.credential.userId !== credential.userId"/>
      </div>
      <div>
        <label for="privateKey">Private Key</label>
        <textarea v-model="credential.privateKey" id="privateKey" name="privateKey" cols="50" placeholder="-----BEGIN PRIVATE KEY-----"></textarea>
        <modified :enable="value.credential && value.credential.privateKey !== credential.privateKey"/>
      </div>
      <div>
        <label for="publicKey">Public Key</label>
        <textarea v-model="credential.publicKey" id="publicKey" name="publicKey" cols="50" placeholder="-----BEGIN CERTIFICATE-----"></textarea>
        <modified :enable="value.credential && value.credential.publicKey !== credential.publicKey"/>
      </div>
    </template>
  </ats>
</template>
<script>
import Ats from './sdk-v3'
import Recruiter from '/user/recruiter/recruiter.entity'
import Search from '/requirement/entity'
import Modified from '/ats/modified'

export default {
  name: 'hippolyte.services.successfactors.config',
  components: { Ats, Modified },
  props: {
    value: Object,
    recruiter: Recruiter,
    search: Search,
    savingConf: Boolean
  },
  methods: {
    onInput (event) {
      this.$emit('input', event)
    }
  }
}
</script>
